// export const API_URL: string = 'http://api.skivio.co/' // 'http://localhost:3001/' // 'http://api.skivio.co/' // 'http://skivio.uk:3001/api/' // 'http://localhost:3001/' // 'http://skivio.uk/api/'

const IS_LOCAL: boolean = false
const IS_LOCAL_API: boolean = false

export const ROOT_URL: string = 'https://getpeyto.app/' // 'https://skivio.co/'
const API_URL_LOCAL: string = 'http://localhost:8080/' // 'https://api.skivio.co/' // 'http://localhost:8080/' // 'https://api.skivio.co/' /// 'http://localhost:3001/' // 'https://api.skivio.co/'
const API_URL_LIVE: string = 'https://api.getpeyto.app/' // 'https://api.skivio.co/'

const VIDEO_FILE_PATH_LOCAL: string = '/uploads/videos/' // 'https://skivio.co/uploads/videos/' // '/uploads/videos/' // 'https://skivio.uk/uploads/videos/' // 'https://api.skivio.co/'
const VIDEO_FILE_PATH_LIVE: string = 'https://skivio.co/uploads/videos/' // '/uploads/videos/' // 'https://skivio.uk/uploads/videos/' // 'https://api.skivio.co/'

export const PROFILE_PIC_URL: string = 'https://skivio.co/uploads/profile_pics/' // '/uploads/profile_pics/' // 'https://skivio.uk/uploads/profile_pics/' // 'http://api.skivio.co/uploads/profile_pics/' // '/imgs/temp/profile_pics/'
export const DOCUMENT_FILE_PATH: string = 'https://skivio.co/uploads/docs/' // '/uploads/docs/'

export const PATH_FACEBOOK_URL: string = 'https://www.facebook.com/profile.php?id=61576161159054'
export const PATH_INSTAGRAM_URL: string = 'https://www.instagram.com/skivio.co'


export function getApiUrl(): string {
	return IS_LOCAL_API ? API_URL_LOCAL : API_URL_LIVE
}

export function getVideoFilePath(): string {
	return IS_LOCAL ? VIDEO_FILE_PATH_LOCAL : VIDEO_FILE_PATH_LIVE
}